import { makeStyles, Theme } from '@material-ui/core';
import "firebase/compat/database";
import React from 'react';
import { BuyLowSellHigh } from './views/BuyLowSellHigh';
import { Projection } from './views/Projection';
import { TopPicks } from './views/TopPicks';
import { WeeklyProjection } from './views/WeeklyProjection';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    textDecoration: 'underline'
  },
  multi: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}));

const App: React.FC<any> = (props: any) => {
  const classes = useStyles(props);

  return <div className={classes.root}>
    <h3>Day To Day Fantasy NBA - CSV Uploader</h3>
    <h5 className={classes.header}>Top Picks</h5>
    <TopPicks/>
    <h5 className={classes.header}>Projections/Draft Ranking</h5>
    <Projection/>
    <h5 className={classes.header}>Weekly Projections</h5>
    <WeeklyProjection/>
    <h5 className={classes.header}>Buy Low Sell High</h5>
    <div className={classes.multi}>
      <BuyLowSellHigh name='Hovav'/>
      <BuyLowSellHigh name='Zilber'/>
    </div>
  </div>
}

export default App;
